/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import MedicineTimeContainer from '../components/MedicineTime';
import { IoMdAddCircleOutline } from "react-icons/io"
import moment from "moment"
import NameBatchModal from '../components/NameBatchModal';
import UserPreferedTimingContainer from '../components/userPreferedTimings';
import { toast } from 'react-toastify';
import { DAY_PARTS } from '../Constants';
import { BiDuplicate } from "react-icons/bi"
import { MdDelete, MdToday } from "react-icons/md"
import { TENANT_COMPANY_MAP } from '../../../utils/constants';
import { getTenantId } from '../../../utils/helpers';
import { countUserPreferredTimingSlots } from '../../../utils/userPreferredTimingsCount';

export default function PrescriptionItem({ updateItem, itemId, Items, userTimings, addItem, deleteItem, isEditable, order, availabilityData, indentItems, onAddToIndent }) {
    const [medicineTimings, setMedicineTimings] = useState(null);
    const [showItemmodal, setShowItemModal] = useState(false);
    const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    const tenantId = getTenantId();
    const isEasydose = process.env.REACT_APP_EASYDOSE_FEATURE_ENABLED === 'true' && tenantId === TENANT_COMPANY_MAP.EAZY;

    useEffect(() => {
        let timings = {};
        Items[itemId]?.meal?.map((meal, ind) => {
            timings[ind] = { meal: Items[itemId]?.meal[ind], time: Items[itemId]?.time[ind] }
        })
        setMedicineTimings(timings)
    }, [Items])

    // Check if this item's itemId appears in other prescription items
    const isItemIdUnique = () => {
        const currentItemId = Items[itemId]?.itemId || Items[itemId]?.item?.id;
        if (!currentItemId) return false;

        const itemsWithSameItemId = Object.keys(Items).filter(prescriptionItemId => {
            const otherItemId = Items[prescriptionItemId]?.itemId || Items[prescriptionItemId]?.item?.id;
            return otherItemId === currentItemId;
        });

        // Return true if only this prescription item has this itemId
        return itemsWithSameItemId.length === 1;
    };

    function UpdatePrescriptionItemsApiCall(newTimings) {
        let meal = [], time = [], payLoadData = {};
        Object.keys(newTimings).map((key) => {
            meal.push(newTimings[key].meal);
            time.push(newTimings[key].time);
        })
        payLoadData['meal'] = meal;
        payLoadData['time'] = time;
        updateItem(itemId, { meal, time });
    }

    /**
        * Adds a new medicine time as same as the last one 
    */
    function AddMedicineTiming(time) {
        let newTimings = { ...medicineTimings };
        let size = Object.keys(newTimings).length;
        if (size == 0) {
            if (time) {
                newTimings[0] = { time: time, meal: 'AFTER' }

            }
            else {
                newTimings[0] = { time: "10:00", meal: "AFTER" }
            }
        }
        else {
            if (time) {
                for (let index = 0; index < size; index++) {
                    if (newTimings[index].time === time) {
                        toast.warn('Time is already added!')
                        return;
                    }
                }
                newTimings[parseInt(Object.keys(newTimings)[size - 1]) + 1] = { time: time, meal: 'AFTER' }
            }
            else {
                newTimings[parseInt(Object.keys(newTimings)[size - 1]) + 1] = { ...Object.values(newTimings)[size - 1] }
            }
        }
        setMedicineTimings(newTimings);
        UpdatePrescriptionItemsApiCall(newTimings);
    }

    /**
         * Deletes a Medicine time
         * @param id  id which is the index of timing
     */
    function deleteMedicineTiming(id) {
        let newTimings = { ...medicineTimings };
        delete newTimings[id]
        setMedicineTimings(newTimings);
        UpdatePrescriptionItemsApiCall(newTimings)
    }

    /**
        * Updates a Medicine time
        * @param id  id of the time to be updated
        * @param name name of the property that has to be updated
        * @param value value to be updated
        * 
    */
    function updateMedicineTiming(id, name, value) {
        let newTimings = { ...medicineTimings };
        newTimings[id][name] = value;
        setMedicineTimings(newTimings);
        UpdatePrescriptionItemsApiCall(newTimings);
    }

    const setTypeOfAdmin = async (e) => {
        if (e.target.value === 'AS_PER_PRESCRIPTION') {
            setMedicineTimings({})
            await await updateItem(itemId, {
                time: [],
                meal: [],
                sunday: false,
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                doseSize: 1,
                startDate: order.startDate,
                duration: 1,
                endDate: order.startDate,
                typeOfAdmin: "AS_PER_PRESCRIPTION"
            })
        } else {
            await updateItem(itemId, { [e.target.name]: e.target.value })
        }
    }

    // Add function to get availability status for this item
    const getAvailabilityStatus = () => {
        if (!availabilityData?.stockAvailability) return null;

        // Get inventoryId from the prescription item
        const inventoryId = Items[itemId]?.inventoryId || Items[itemId]?.item?.inventoryId;
        if (!inventoryId) return null;

        const stockInfo = availabilityData.stockAvailability[inventoryId];
        if (!stockInfo) return null;

        const easydoseAvailable = stockInfo.easydoseStore?.isAvailable || false;
        const opPharmacyAvailable = stockInfo.opPharmacy?.isAvailable || false;

        // Return status: 'none' = not available in both, 'partial' = available in OP only
        if (!easydoseAvailable && !opPharmacyAvailable) {
            return 'none'; // Gray - not available in both
        } else if (!easydoseAvailable && opPharmacyAvailable) {
            return 'partial'; // Faded color - available in OP only
        }
        return 'available'; // Available in both (or at least easydose)
    };

    const availabilityStatus = getAvailabilityStatus();

    // Determine background color based on availability
    const getBackgroundColor = () => {
        if (availabilityStatus === 'none') {
            return 'bg-gray-200'; // Gray when not available in both
        } else if (availabilityStatus === 'partial') {
            return 'bg-yellow-50'; // Faded yellow when available in OP only
        }
        return 'bg-white'; // Default white
    };

    // Determine border color
    const getBorderColor = () => {
        if (availabilityStatus === 'none') {
            return 'border-gray-400'; // Gray border
        } else if (availabilityStatus === 'partial') {
            return 'border-yellow-300'; // Yellow border
        }
        return 'border-gray-200'; // Default border
    };

    const isAvailableForIndent = () => {
        if (!availabilityData?.stockAvailability) return false;

        const inventoryId = Items[itemId]?.inventoryId || Items[itemId]?.item?.inventoryId;
        if (!inventoryId) return false;

        const stockInfo = availabilityData.stockAvailability[inventoryId];
        if (!stockInfo) return false;

        const easydoseAvailable = stockInfo.easydoseStore?.isAvailable || false;
        const opPharmacyAvailable = stockInfo.opPharmacy?.isAvailable || false;

        // Show button if not available in easydose but available in OP pharmacy
        return !easydoseAvailable && opPharmacyAvailable;
    };

    const isInIndentList = indentItems?.some(item => item.prescriptionItemId === itemId);

    return (

        <div className={`flex flex-col rounded-2xl w-full p-5 gap-2 border-solid shadow-soft-xl ${getBackgroundColor()} ${getBorderColor()} ${Items[itemId]?.messages?.length > 0 ? " border-2 border-red-300" : "border"}`}
            id={`prescriptionItem-${itemId}`} >
            {Items[itemId]?.messages?.map((message, key) => {
                return (
                    <>
                        <div key={key} className='bg-red-50 border border-red-200 rounded-lg p-3'>
                            <p className='text-red-600 text-sm font-medium'>{message.text}</p>
                        </div>
                    </>
                )
            })}

            {/* Header with medicine name and form fields */}
            <div className='flex flex-row flex-wrap items-start justify-between gap-4 mb-3'>
                <div className="flex flex-row gap-1 flex-1">
                    <div className='flex flex-row gap-3 items-center' >
                        <div className='flex flex-col gap-2'>
                            <div className="flex-col gap-1">
                                <div className='flex flex-col'>
                                    <h3 className='text-lg font-semibold text-gray-800 max-w-[300px] overflow-hidden whitespace-nowrap'>{Items[itemId]?.item?.name} <br /> <span className='text-xs text-gray-500 p-0 m-0'>{Items[itemId]?.itemBatch?.batch || ''}</span></h3>
                                    <h3 className='text-sm text-gray-600 max-w-[300px] overflow-hidden whitespace-nowrap'>{Items[itemId]?.item?.manufacture || 'NA'}</h3>
                                </div>
                            </div>
                            <div className='flex flex-row gap-2 justify-start'>
                                <button
                                    className='p-2 rounded-lg bg-purple-100 text-purple-600 hover:bg-purple-200 transition-colors duration-200'
                                    onClick={() => { addItem(itemId, 'duplicate') }}
                                    title="Duplicate item"
                                    disabled={!isEditable}
                                >
                                    <BiDuplicate className="text-lg" />
                                </button>
                                <button
                                    className='p-2 rounded-lg bg-gray-100 text-gray-600 hover:bg-gray-200 transition-colors duration-200'
                                    onClick={() => { addItem(itemId, 'today'); }}
                                    title="Add for today"
                                    disabled={!isEditable}
                                >
                                    <MdToday className="text-lg" />
                                </button>
                                {!isItemIdUnique() && (
                                    <button
                                        className='p-2 rounded-lg bg-red-100 text-red-600 hover:bg-red-200 transition-colors duration-200'
                                        onClick={() => { deleteItem(itemId) }}
                                        title="Delete item"
                                        disabled={!isEditable}
                                    >
                                        <MdDelete className="text-lg" />
                                    </button>
                                )}
                                {isEasydose && isAvailableForIndent() && (
                                    <div className="flex items-center">
                                        <button
                                            className={`px-4 py-2.5 rounded-lg font-semibold text-sm transition-all shadow-md hover:shadow-lg ${isInIndentList
                                                    ? 'bg-blue-600 text-white hover:bg-blue-700'
                                                    : 'bg-orange-500 text-white hover:bg-orange-600'
                                                } ${!isEditable ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                                            onClick={() => onAddToIndent(itemId, Items[itemId])}
                                            disabled={!isEditable}
                                            title={isInIndentList ? "Remove from indent" : "Add to indent"}
                                        >
                                            {isInIndentList ? "✓ In Indent" : "Add To Indent"}
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    {/* Form fields next to medicine name */}
                    {
                        Items[itemId]?.typeOfAdmin !== 'AS_PER_PRESCRIPTION' && <div className='flex flex-col'>
                            <label className='text-xs font-medium text-gray-700 mb-1'>Start Date</label>
                            <input
                                className='rounded-md h-10 text-xs px-2 border border-gray-300 focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200'
                                onChange={(e) => { updateItem(itemId, { [e.target.name]: moment(e.target.value).format() }) }}
                                value={moment(Items[itemId]?.startDate).format('YYYY-MM-DD')}
                                name='startDate'
                                type='date'
                                disabled={!isEditable}
                            />
                        </div>
                    }
                    {Items[itemId]?.typeOfAdmin !== 'DATE' && Items[itemId]?.typeOfAdmin !== 'AS_PER_PRESCRIPTION' && (
                        <div className='flex flex-col'>
                            <label className='text-xs font-medium text-gray-700 mb-1'>Duration</label>
                            <input
                                className='rounded-md h-10 text-xs px-2 border border-gray-300 focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200'
                                min={1}
                                onChange={(e) => { updateItem(itemId, { [e.target.name]: parseInt(e.target.value) }) }}
                                value={Items[itemId]?.duration}
                                name='duration'
                                type='number'
                                disabled={!isEditable}
                            />
                        </div>
                    )}
                    {Items[itemId]?.typeOfAdmin !== 'AS_PER_PRESCRIPTION' && <div className='flex flex-col'>
                        <label className='text-xs font-medium text-gray-700 mb-1'>End Date</label>
                        <input
                            className='rounded-md h-10 text-xs px-2 border border-gray-300 bg-gray-50 cursor-not-allowed'
                            disabled={!isEditable}
                            value={moment(Items[itemId]?.endDate).format('YYYY-MM-DD')}
                            name='endDate'
                            type='date'
                        />
                    </div>}
                    <div className='flex flex-col'>
                        <label className='text-xs font-medium text-gray-700 mb-1'>Type</label>
                        <select
                            className='rounded-md max-w-[100px] h-10 text-xs px-2 border border-gray-300 focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200 bg-white'
                            name='typeOfAdmin'
                            value={Items[itemId]?.typeOfAdmin}
                            onChange={setTypeOfAdmin}
                            disabled={!isEditable}
                        >
                            <option value="DAYS">Days</option>
                            <option value="DATE">Date</option>
                            <option value="ALTERNATE">Alternate</option>
                            <option value="AS_PER_PRESCRIPTION">As Per Prescription</option>
                        </select>
                    </div>
                    {Items[itemId]?.typeOfAdmin !== 'AS_PER_PRESCRIPTION' && <div className='flex flex-col'>
                        <label className='text-xs font-medium text-gray-700 mb-1'>Dose Size</label>
                        <select
                            className='rounded-md max-w-[100px] h-10 text-xs px-1 border border-gray-300 focus:border-blue-500 focus:ring-1 focus:ring-blue-200 transition-all duration-200 bg-white'
                            value={Items[itemId]?.doseSize}
                            onChange={(e) => { updateItem(itemId, { 'doseSize': parseFloat(e.target.value) }) }}
                            disabled={!isEditable}
                        >
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="0.5">0.5</option>
                            <option value="0.25">0.25</option>
                        </select>
                    </div>}

                    {/* Days selector */}
                    {Items[itemId]?.typeOfAdmin === 'DAYS' && (
                        <div className='flex flex-col'>
                            <label className='text-xs font-medium text-gray-700 mb-1'>Days</label>
                            <div className='flex flex-row gap-1 flex-wrap'>
                                {days.map((day) => {
                                    return (
                                        <button
                                            key={day}
                                            onClick={() => { updateItem(itemId, { [day]: !Items[itemId][day] }) }}
                                            className={`cursor-pointer text-xs rounded-md h-8 w-8 flex items-center justify-center font-medium border transition-all duration-200 ${Items[itemId][day]
                                                ? 'bg-blue-500 text-white border-blue-500'
                                                : 'bg-white text-gray-600 border-gray-300 hover:border-blue-300 hover:bg-blue-50'}`}
                                            title={day.charAt(0).toUpperCase() + day.slice(1)}
                                            disabled={!isEditable}
                                        >
                                            {day.charAt(0).toUpperCase()}
                                        </button>
                                    )
                                })}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {showItemmodal && <NameBatchModal item={Items[itemId]?.item} batchesItem={Items[itemId]?.itemBatches} onClose={() => setShowItemModal(false)} type='update' prescriptionItemId={itemId} updateItem={updateItem} modalToggle={setShowItemModal} />}

            {/* Main content area with table and medicine timings */}
            <div className='flex flex-row gap-2 items-start'>
                {/* Invoice table */}
                {Items[itemId]?.invoiceItems?.length > 0 && (
                    <div className='bg-gray-50 rounded-lg  flex-shrink-0'>
                        <div className="overflow-x-auto">
                            <table className="min-w-full">
                                <thead>
                                    <tr className="border-b border-gray-200">
                                        <th className='text-xs font-semibold text-teal-600 text-left py-1 px-2'>Batch</th>
                                        <th className='text-xs font-semibold text-teal-600 text-left py-1 px-2'>Expiry</th>
                                        <th className='text-xs font-semibold text-teal-600 text-left py-1 px-2'>MRP</th>
                                        <th className='text-xs font-semibold text-teal-600 text-left py-1 px-2'>Qty</th>
                                        <th className='text-xs font-semibold text-teal-600 text-left py-1 px-2'>Disc(₹)</th>
                                        <th className='text-xs font-semibold text-teal-600 text-left py-1 px-2'>Amount(₹)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Items[itemId].invoiceItems.map((invoiceItem, index) => {
                                        return <tr key={invoiceItem?.id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                            <td className='text-xs font-medium text-gray-700 py-1 px-2'>{invoiceItem?.batch || 'NA'}</td>
                                            <td className='text-xs text-gray-600 py-1 px-2'>{moment(invoiceItem?.expireDate).format("MM/YY") || 'NA'}</td>
                                            <td className='text-xs text-gray-600 py-1 px-2'>{invoiceItem?.mrp?.toFixed(2) || 'NA'}</td>
                                            <td className='text-xs text-gray-600 py-1 px-2'>{invoiceItem?.quantity || 'NA'}</td>
                                            <td className='text-xs text-gray-600 py-1 px-2'>{invoiceItem?.discount?.toFixed(2) || 'NA'}</td>
                                            <td className='text-xs font-medium text-gray-800 py-1 px-2'>{invoiceItem?.amount?.toFixed(2) || 'NA'}</td>
                                        </tr>
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}

                {/* Medicine timing section - using remaining space */}
                {medicineTimings && Items[itemId]?.typeOfAdmin !== 'AS_PER_PRESCRIPTION' && (
                    <div className='flex-1'>
                        <div className='flex flex-col gap-3'>
                            <div className='flex flex-col'>
                                <span className='text-xs text-gray-500 mb-2'>Quick Add</span>
                                <div className='flex flex-row flex-wrap gap-2'>
                                    {countUserPreferredTimingSlots(userTimings) > 0 && userTimings ? (
                                        DAY_PARTS.map((key, index) => {
                                            if (Object.prototype.hasOwnProperty.call(userTimings, key)) {
                                                if (key === 'CUSTOM') {
                                                    return userTimings[key].map((timing) => {
                                                        return <UserPreferedTimingContainer key={index} dayPart={key} time={timing} AddMedicineTiming={AddMedicineTiming} />
                                                    })
                                                }
                                                return <UserPreferedTimingContainer key={index} dayPart={key} time={userTimings[key]} AddMedicineTiming={AddMedicineTiming} />
                                            }
                                        })
                                    ) : (
                                        <>
                                            <UserPreferedTimingContainer
                                                key="preset-9am"
                                                dayPart="BREAKFAST"
                                                time="09:00"
                                                AddMedicineTiming={AddMedicineTiming}
                                                disabled={!isEditable}
                                            />
                                            <UserPreferedTimingContainer
                                                key="preset-2pm"
                                                dayPart="LUNCH"
                                                time="14:00"
                                                AddMedicineTiming={AddMedicineTiming}
                                                disabled={!isEditable}
                                            />
                                            <UserPreferedTimingContainer
                                                key="preset-9pm"
                                                dayPart="DINNER"
                                                time="21:00"
                                                AddMedicineTiming={AddMedicineTiming}
                                                disabled={!isEditable}
                                            />
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className='flex flex-col'>
                                <div className='flex flex-row flex-wrap items-center justify-start gap-2'>
                                    {Object.keys(medicineTimings)?.map((key) => {
                                        return (<MedicineTimeContainer updateMedicineTiming={updateMedicineTiming} deleteMedicineTiming={deleteMedicineTiming} ind={key} key={key} timing={medicineTimings[key]} isEditable={isEditable} />)
                                    })}
                                    <button
                                        className='p-2 rounded-lg border-2 border-dashed border-blue-300 text-blue-500 hover:border-blue-500 hover:bg-blue-50 transition-all duration-200'
                                        onClick={() => { AddMedicineTiming() }}
                                        title="Add timing"
                                        disabled={!isEditable}
                                    >
                                        <IoMdAddCircleOutline className='text-2xl' />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div >
    )
}
